import { CognitoMgr } from './CognitoMgr';
import { AuthenticationDetails, CognitoUser, CognitoUserSession, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { Controller } from '../Controller';
import { ApiHelper } from '../helpers/ApiHelper';
import { AuthError } from '../errors';
import { ApiError } from '../errors';

export class LoginMgr {

  constructor() {
    //console.log('LoginMgr()');
    this.cognitoMgr = new CognitoMgr();
  }

  bootstrap(callback) {
    if (this.getCurrentUser()) {
      this.fetchUserToken(this.getCurrentUser(), function (err) {
        if (err) callback(new AuthError('Authentication error. Check your internet connection and try again.', err));
        if (!Controller.get().userMgr().getAppUser()) {
          this._fetchAppUser(callback);
        } else {
          callback(null, {})
        }
      }.bind(this));
    } else {
      callback(null, null)
    }
  }

  signUp(newUserId, phone, email, password, callback) {
    const attributeList = [];
    const dataPhoneNumber = {
      Name: 'phone_number',
      Value: phone
    };
    const attributePhoneNumber = new CognitoUserAttribute(dataPhoneNumber);
    attributeList.push(attributePhoneNumber);

    if (email) {
      const dataEmail = {
        Name: 'email',
        Value: email
      };
      const attributeEmail = new CognitoUserAttribute(dataEmail);
      attributeList.push(attributeEmail);
    }

    this.cognitoMgr.getUserPool().signUp(newUserId, password, attributeList, null, function (err, result) {
      if (err) {
        const action = this._nextAction(err);
        if (action) {
          callback(null, action);
        } else {
          callback(new AuthError('signUp onFailire', err));
        }
        return;
      }
      callback(null, {
        code: 'SUCCESS',
        message: 'The verification code has been sent to you'
      });
    }.bind(this));
  }

  confirmRegistration(newUserId, verificationCode, callback) {
    const cognitoUser = new CognitoUser({
      Username: newUserId,
      Pool: this.cognitoMgr.getUserPool()
    });

    cognitoUser.confirmRegistration(verificationCode, false, function (err, result) {
      if (err) {
        const action = this._nextAction(err);
        if (action) {
          callback(null, action);
        } else {
          callback(new AuthError('authenticateUser onFailire', err));
        }
        return;
      }
      callback(null, {
        code: 'SUCCESS'
      });
    }.bind(this));
  }

  signIn(username, password, callback) {
    const thisObj = this
    const authenticationDetails = new AuthenticationDetails({
      Username: username,
      Password: password,
    });
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.cognitoMgr.getUserPool()
    });
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (session, userConfirmationNecessary) {
        console.log('authenticateUser onSuccess:', userConfirmationNecessary);
        thisObj._storeToken(session);
        thisObj._fetchAppUser(function (err, data) {
          if (err) {
            callback(err); return;
          }
          callback(null, { code: 'SUCCESS' });
        });
      },
      onFailure: function (err) {
        console.log('authenticateUser: onFailure:', err);
        const action = thisObj._nextAction(err);
        if (action) {
          callback(null, action);
        } else {
          callback(new AuthError('authenticateUser onFailire', err));
        }
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        console.log('newPasswordRequired:', userAttributes, requiredAttributes);
        callback(null, {
          code: 'NEW_PASSWORD_REQUIRED',
          message: 'You have to set a new password.',
          receivedUserAttributes: userAttributes,
          cognitoUser: cognitoUser // required for the session
        }
        );
      },
      mfaRequired: function (challengeName, challengeParameters) {
        console.log('newPasswordRequired:', challengeName, challengeParameters);
        callback(new AuthError('mfaRequired: Not Implemented'));
      },
      customChallenge: function (challengeParameters) {
        console.log('newPasswordRequired:', challengeParameters);
        callback(new AuthError('customChallenge: Not Implemented'));
      }
    });
  }

  getCurrentUser() {
    return this.cognitoMgr.getCurrentUser();
  }

  fetchUserToken(cognitoUser, callback) {
    if (!cognitoUser) {
      callback(new AuthError('user cannot be null'));
    }

    cognitoUser.getSession(function (err, session) {
      if (err) {
        console.log('getSession error:', err);
        callback(new AuthError('getSession error', err));
        return
      }
      if (!session.isValid()) {
        callback(new AuthError('Session is not valid'))
        return
      }
      console.log('Valid Token ready:');
      this._storeToken(session);
      callback(null);
    }.bind(this));
  }

  signOut() {
    const user = this.getCurrentUser();
    this._removeLoginFlagLocalStorage();
    if (user) {
      user.signOut();
    } else {
      console.log('nothing to signOut')
    }
    this._storeToken(null);
  }

  forgotPassword(username, callback) {
    const thisObj = this
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.cognitoMgr.getUserPool()
    });
    cognitoUser.forgotPassword({
      onSuccess: function (data) {
        console.log('forgotPassword onSuccess:', data);
        callback(null, {
          code: 'SUCCESS',
          message: 'The password reset code has been sent to you'
        });
      },
      onFailure: function (err) {
        console.log('forgotPassword onFailure:', err);
        const action = thisObj._nextAction(err);
        if (action) {
          callback(null, action);
        } else {
          callback(new AuthError('authenticateUser onFailire', err));
        }
      },
      inputVerificationCode: function (data) {
        console.log('forgotPassword inputVerificationCode:', data);
        callback(null, {
          code: 'SUCCESS',
          message: 'The password reset code has been sent to:' + data.CodeDeliveryDetails.Destination
        }
        );
      }
    });
  }

  confirmResetPassword(verificationCode, username, password, callback) {
    const thisObj = this
    const cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.cognitoMgr.getUserPool()
    });

    cognitoUser.confirmPassword(verificationCode, password, {
      onSuccess: function () {
        callback(null, {
          code: 'SUCCESS',
          message: 'You have successfully reset your password. Login with your new password'
        });
      },
      onFailure: function (err) {
        console.log('confirmPassword onFailure:', err);
        const action = thisObj._nextAction(err);
        if (action) {
          callback(null, action);
        } else {
          callback(new AuthError('authenticateUser onFailire', err));
        }
      }
    });
  }

  completeNewPasswordChallenge(username, newPassword, cognitoUser, userAttributes, callback) {
    const thisObj = this

    // the api doesn't accept this field back
    delete userAttributes.email_verified;
    delete userAttributes.sms_verified;

    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
      onSuccess: function (session) {
        callback(null, {
          code: 'SUCCESS',
          message: 'You have successfully set your password. Login with your new password.'
        });
      },
      onFailure: function (err) {
        console.log('completeNewPasswordChallenge onFailure:', err);
        const action = thisObj._nextAction(err);
        if (action) {
          callback(null, action);
        } else {
          callback(new AuthError('completeNewPasswordChallenge onFailire', err));
        }
      },
      mfaRequired: function (challengeName, challengeParameters) {
        console.log('completeNewPasswordChallenge:', challengeName, challengeParameters);
        callback(new AuthError('completeNewPasswordChallenge::mfaRequired: Not Implemented'));
      },
      customChallenge: function (challengeParameters) {
        console.log('completeNewPasswordChallenge:', challengeParameters);
        callback(new AuthError('completeNewPasswordChallenge::customChallenge: Not Implemented'));
      }
    });
  }

  restoreLoginSession(callback) {
    this.cognitoMgr.getUserPool().storage.sync(callback);
  }

  _storeToken(session) {
    if (session) {
      Controller.get().userMgr().setUserToken(session.getAccessToken().getJwtToken());
    } else {
      Controller.get().userMgr().setUserToken(null);
      Controller.get().userMgr().setAppUser(null);
    }
  }

  _fetchAppUser(callback) {
    ApiHelper.call({ method: 'GET', endPoint: ApiHelper.makeUrlPath(['users', 'me']) }, function (err, data) {
      if (err) {
        callback(new ApiError(err)); return;
      }
      Controller.get().userMgr().setAppUser(data);
      callback(null, data)
    })
  }

  _nextAction(err) {
    console.log('err', err);
    if (err.code === 'UserNotFoundException') {
      return {
        code: 'USER_NOT_FOUND',
        message: 'We are not able to identify your email/phone. Please signup and then login.'
      }
    } else if (err.code === 'NotAuthorizedException') {
      return {
        code: 'WRONG_CREDENTIALS',
        message: 'Your username or password is wrong. Try again.'
      }
    } else if (err.code === 'CodeMismatchException') {
      return {
        code: 'WRONG_VERIFICATION_CODE',
        message: 'Invalid verification code provided. Try again.'
      }
    } else if (err.code === 'InvalidPasswordException') {
      return {
        code: 'PASSWORD_NOT_AS_PER_POLICY',
        message: 'Password should be minumum 8 characters with numbers, uppercase and lowercase letters.'
      }
    } else if (err.code === 'InvalidParameterException') { // Short passwords trigger this, should have been InvalidPasswordException
      return {
        code: 'PASSWORD_NOT_AS_PER_POLICY',
        message: 'Password should be minumum 8 characters with numbers, uppercase and lowercase letters.'
      }
    } else if (err.code === 'NetworkingError') {
      return {
        code: 'NETWORKING_ERROR',
        message: 'Network problem. Check your internet connection.'
      }
    } else if (err.code === 'AliasExistsException') {
      return {
        code: 'USER_EXISTS',
        message: 'You already have an account. You can login instead of signup.'
      }
    } else if (err.code === 'UsernameExistsException') {
      return {
        code: 'USER_EXISTS',
        message: 'You already have an account. You can directly login. Reset the password if required.'
      }
    } else {
      return {
        code: 'INTERNAL_ERROR',
        message: 'An internal problem occurred. Check your username, password and other parameters and try again.'
      }
    }
  }

  setLoginFlagLocalStorage() {
    localStorage.setItem('LOGGED_IN', 'YES');
  }

  isLoggedIn() {
    if(localStorage.getItem('LOGGED_IN') === 'YES') {
      return true
    } else {
      return false
    }
  }

  _removeLoginFlagLocalStorage() {
    localStorage.removeItem('LOGGED_IN');
  }
}



// WEBPACK FOOTER //
// ./src/common/mgrs/LoginMgr.js